<template>
  <div class="image-text-setting-ratio common-label-flex">
    <span>表示比率</span>
    <div class="common-select">
      <select
        v-model="selectValue"
        class="form-control"
        :disabled="disabled"
      >
        <option
          v-for="option in options"
          :key="option.value"
          :value="option.value"
        >
          {{ option.text }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'value',
    'disabled',
  ],
  data () {
    return {
      options: [
        { text: '画像1 : テキスト1', value: 'imageOneToTextOne' },
        { text: '画像2 : テキスト1', value: 'imageTwoToTextOne' },
        { text: '画像1 : テキスト2', value: 'imageOneToTextTwo' },
        { text: '画像1 : テキスト3', value: 'imageOneToTextThree' },
      ]
    }
  },
  computed: {
    selectValue: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('updateHorizontalDisplayRatio', newValue)
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.common-label {
  white-space: nowrap;
  &::before {
    left: 32px;
  }
}
:disabled {
  background-color: rgb(190, 189, 189);
}
</style>
